import { PostEntity } from '~/post/PostEntity';
import { RpcUpdate } from '~/post/types';
import { selectCurrentProfileId } from '~/profile-sidebar/selectors';
import type { RootState } from '~/store/reducers';

export const selectProfileIdByPostId =
  (postId: string) =>
  (state: RootState): string | null => {
    const foundId = Object.keys(state.queue.byProfileId || {}).find(
      (profileId) => {
        // find the profileId that has this postId in it
        return Object.keys(state.queue.byProfileId[profileId].posts).some(
          (id) => {
            return id === postId;
          }
        );
      }
    );

    return foundId || null;
  };

export const selectPostById = (postId: string) => (state: RootState) => {
  const profileId = selectProfileIdByPostId(postId)(state);

  return profileId ? state.queue.byProfileId[profileId].posts[postId] : null;
};

export const selectFailedPostsCount = (state: RootState): number => {
  const profileId = selectCurrentProfileId(state);

  const posts: Record<string, RpcUpdate> =
    state.queue.byProfileId[profileId]?.posts || {};

  return Object.keys(posts).reduce((acc, key) => {
    const post = posts[key];
    if (PostEntity.hasError(post)) {
      acc += 1;
    }

    return acc;
  }, 0);
};
